import { baromoneyService, hubService, userService, } from '@/services';
import hubStorage from '@/helpers/hubStorage';
import { PERMISSION_PATTERN } from '@/utils/regularExpression';
import { userPermission } from '@/constants';
import { vuexEventPathGenerator } from '@/utils';
import { hubStatusTypeCodeObj } from '@/constants/hubManagement/hubStatusOptionList';
import { mutationType } from './mutations';
import { authActionType } from '../auth/actions';
export const actionType = {
    login: 'login',
    logout: 'logout',
    /** 유저 초기화 */
    initUser: 'initUser',
    /** 유저 초기화 해제 */
    clearUser: 'clearUser',
    getHubInfo: 'getHubInfo',
    setHubInfo: 'setHubInfo',
    getBaromoney: 'getBaromoney',
    setBaromoney: 'setBaromoney',
    getBaromoneyHistory: 'getBaromoneyHistory',
    getUserInfo: 'getUserInfo',
    setUserInfo: 'setUserInfo',
    setUserPermission: 'setUserPermission',
};
export const userActionType = vuexEventPathGenerator(actionType, 'user');
const action = {
    async [actionType.login]({ dispatch }, payload) {
        await dispatch(authActionType.getAccessToken, payload, {
            root: true,
        });
        await dispatch(actionType.initUser);
    },
    async [actionType.logout]({ dispatch }) {
        await dispatch(actionType.clearUser);
        window.location.replace('/');
    },
    async [actionType.initUser]({ dispatch, commit, state }) {
        // 유저정보 먼저 가져와야 안정 보장
        await dispatch(actionType.getUserInfo);
        await Promise.all([
            dispatch(actionType.getHubInfo),
            dispatch(actionType.getBaromoney),
            dispatch('systemCode/getBankCode', null, {
                root: true,
            }),
        ]);
        if (state.userInfo.level >= 70) {
            commit(mutationType.SET_INIT_USER, true);
            return;
        }
        // 허브 상태가 중지면 로그아웃
        if (state.hubInfo.useYn === hubStatusTypeCodeObj.S
            || state.hubInfo.useYn === hubStatusTypeCodeObj.E
            || state.hubInfo.useYn === hubStatusTypeCodeObj.P
            || state.hubInfo.useYn === hubStatusTypeCodeObj.N) {
            // eslint-disable-next-line no-alert
            alert('허브상태에 따른 접속 불가. 관리자CS를 사용해주세요.');
            await dispatch(actionType.logout);
            return;
        }
        dispatch(actionType.setUserPermission);
        commit(mutationType.SET_INIT_USER, true);
    },
    async [actionType.clearUser]({ dispatch, commit }) {
        await Promise.all([
            dispatch(authActionType.removeAccessToken, null, {
                root: true,
            }),
            dispatch(actionType.setUserInfo, null),
            dispatch(actionType.setHubInfo, null),
            dispatch(actionType.setBaromoney, null),
            dispatch('bank/setVirtualBank', null, {
                root: true,
            }),
        ]);
        hubStorage.removeSelectedHubInfo();
        hubStorage.clearSessionStorage();
        commit(mutationType.SET_INIT_USER, false);
    },
    async [actionType.getHubInfo]({ dispatch, commit, state }) {
        if (state?.userInfo?.level && state.userInfo.level >= 70) {
            return;
        }
        const { data } = await hubService.getHubInfo();
        commit(mutationType.SET_HUB_INFO, data);
        const hubId = data.code;
        await dispatch('hub/getAgencyShareInfo', {
            hubId,
        }, {
            root: true,
        });
    },
    async [actionType.setHubInfo]({ dispatch, commit }, payload) {
        await dispatch('hub/setAgencyShareInfo', [], {
            root: true,
        });
        commit(mutationType.SET_HUB_INFO, payload);
    },
    async [actionType.getBaromoney]({ state, commit }) {
        if (state?.userInfo?.level && state.userInfo.level >= 70) {
            return;
        }
        const response = await baromoneyService.getBaromoney();
        commit(mutationType.SET_BAROMONEY, response.data);
    },
    async [actionType.setBaromoney]({ commit }, payload) {
        commit(mutationType.SET_BAROMONEY, payload);
    },
    async [actionType.getBaromoneyHistory]({ commit }, payload) {
        const response = await baromoneyService.getBaromoneyHistory(payload);
        commit(mutationType.SET_BAROMONEY_HISTORY, {
            baromoneyHistory: response.data.list,
        });
    },
    async [actionType.getUserInfo]({ commit }) {
        const response = await userService.getUserInfo();
        commit(mutationType.SET_USER_INFO, response.data);
    },
    async [actionType.setUserInfo]({ commit }, payload) {
        commit(mutationType.SET_USER_INFO, payload);
    },
    // 문자열 권한 파싱 작업
    async [actionType.setUserPermission]({ state, commit }) {
        const { userInfo: { clientMenuAuth, }, } = state;
        const splitPermission = clientMenuAuth
            .split(PERMISSION_PATTERN)
            .reduce((acc, it) => {
            acc.add(it);
            return acc;
        }, new Set());
        // TODO: 테스트를 위해 임시로 추가
        splitPermission
            // GET_TEMP는 볼 수 있지만 GET_TEMP2는 볼 수 없음
            .add(userPermission.P_GET_TEMPORARY)
            .add(userPermission.N_GET_TEMP2);
        commit(mutationType.SET_PERMISSION, splitPermission);
    },
};
export default action;
